var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewShare({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "210mm",
    height: "297mm",
    viewBox: "0 0 210 297",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M285.246 105.246h389.25v389.25h-389.25zm0 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    transform: "matrix(.52143 0 0 .49623 -145.297 4.13)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M604.738 354.723c-20.05 0-38.066 8.55-50.777 22.125l-129.574-71.961c.058-1.332.176-2.66.176-4.07 0-1.07-.137-2.172-.165-3.231l131.29-72.895c12.597 12.493 29.902 20.215 49.039 20.215 38.464 0 69.687-31.265 69.687-69.824.016-38.605-31.207-69.871-69.676-69.871-38.433 0-69.652 31.266-69.652 69.871 0 2.04.14 4.113.32 6.16l-129.652 71.973c-12.734-13.617-30.738-22.238-50.86-22.238-38.48 0-69.675 31.25-69.675 69.855 0 38.566 31.195 69.86 69.676 69.86 19.812 0 37.644-8.317 50.332-21.649l130.015 72.2c-.015 1.1-.156 2.179-.156 3.335 0 38.598 31.219 69.852 69.652 69.852 38.465 0 69.684-31.254 69.684-69.852.008-38.598-31.215-69.855-69.684-69.855m0 0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewShare);
export default __webpack_public_path__ + "static/media/new_share.9b4fc5861054ddda538bb28e3b5b0215.svg";
export { ForwardRef as ReactComponent };